export const PRESENCE_STATUS_OPTIONS = [
    { value: 'available', label: 'Available', colorClass: 'bg-emerald-500', textClass: 'text-emerald-600' },
    { value: 'busy', label: 'Busy', colorClass: 'bg-amber-500', textClass: 'text-amber-600' },
    { value: 'away', label: 'Away', colorClass: 'bg-yellow-500', textClass: 'text-yellow-600' },
    { value: 'do_not_disturb', label: 'Do Not Disturb', colorClass: 'bg-red-500', textClass: 'text-red-600' },
];

export const PRESENCE_DURATION_OPTIONS = [
    { value: '', label: 'No auto-clear' },
    { value: '1', label: 'Auto-clear after 1 hour' },
    { value: '4', label: 'Auto-clear after 4 hours' },
    { value: '8', label: 'Auto-clear after 8 hours' },
];

const LEGACY_STATUS_ALIASES = {
    online: 'available',
    offline: 'available',
    dnd: 'do_not_disturb',
};

export function normalizePresenceStatus(status) {
    const value = String(status || '').trim().toLowerCase();
    const aliased = LEGACY_STATUS_ALIASES[value] || value;
    return PRESENCE_STATUS_OPTIONS.some((option) => option.value === aliased) ? aliased : 'available';
}

export function getPresenceStatusOption(status) {
    const normalized = normalizePresenceStatus(status);
    return PRESENCE_STATUS_OPTIONS.find((option) => option.value === normalized) || PRESENCE_STATUS_OPTIONS[0];
}

function toValidDate(value) {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function isPresenceExpired(expiresAt, now = new Date()) {
    const expiry = toValidDate(expiresAt);
    const basis = toValidDate(now);
    return Boolean(expiry && basis && expiry.getTime() <= basis.getTime());
}

export function resolvePresenceRow(row, now = new Date()) {
    if (isPresenceExpired(row?.status_expires_at, now)) {
        return {
            status: 'available',
            statusExpiresAt: null,
            expired: true,
        };
    }
    return {
        status: normalizePresenceStatus(row?.status),
        statusExpiresAt: row?.status_expires_at || null,
        expired: false,
    };
}

export function buildPresenceUpsert({ userId, orgId, status, durationHours = '', now = new Date() } = {}) {
    const stamp = toValidDate(now) || new Date();
    const normalizedStatus = normalizePresenceStatus(status);
    const hours = Number(durationHours);
    const expiresAt = normalizedStatus !== 'available' && Number.isFinite(hours) && hours > 0
        ? new Date(stamp.getTime() + hours * 60 * 60 * 1000).toISOString()
        : null;

    return {
        user_id: userId,
        org_id: orgId,
        status: normalizedStatus,
        status_expires_at: expiresAt,
        updated_at: stamp.toISOString(),
    };
}
